import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./PopupChiTiet";
import { useSelector, useDispatch } from "react-redux";
import { updateSearch } from "../../../actions/ChoThongTin/DanhSachVay";
import  danhSachThongTinVayApi  from "../../../service/ChoThongTin/danhSachThongTinVayApi";
import { BtnThongTinVay } from "./BtnThongTinVay";
import moment from "moment";
import { formatNumber, formatMoney } from 'utils/currencyFormat';

export const TableDanhSach = () => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.danhSachThongTinVay);
  const onSearch = () => {
    danhSachThongTinVayApi.danhSachDangKyVay(dataSearch).then((response) => {
      dispatch(
        updateSearch({
          ...dataSearch,
          lstDanhSach: response.data.List,
          iTotal: response.data.iTotal,
        })
      );
    });
  }
  const handlePageChange = (pageNumber) => {
    dataSearch.iPageIndex = pageNumber;
    dispatch(
      updateSearch({
        ...dataSearch,
        iPageIndex: pageNumber,
      })
    );
    onSearch();
  };


  return (
    <div className="Left808x200 Table-main-new">
      <div className="table-mobile sticky-table-bh2 table-mobile-hover">
        <div className="custom-table-wrapper">
          <div className="table-headers">
            <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
              <p className="text-center">
                STT
                <br />{" "}
                <span className="red">
                  [ {dataSearch.iTotal} ]
                </span>
              </p>
            </div>
            <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
              <p className="tab-header  text-center">Mã thông tin</p>
            </div>
            <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
              <p className="tab-header  text-center">Thời gian đăng ký</p>
            </div>
            <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
              <p className="tab-header  text-center">Họ và tên</p>
            </div>
            <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
              <p className="text-center">Địa chỉ</p>
            </div>

            <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
              <p className="text-left">Số tiền vay</p>
            </div>
            <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
              <p className="text-left">Điện thoại</p>
            </div>
            <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
              <p className="tab-header text-left">Chức năng</p>
            </div>
          </div>

          <div className={"custom-table-body " +
          (dataSearch.iTotal === 0 ? "hidden" : "")}>
            {dataSearch.lstDanhSach.map((item, index) => (
              <div className="custom-table-row" key={"item" + index}>
                <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
                  <span className="mobile-column-name">STT</span>
                  <div className="center-wrapper">
                    <p className="text-center">{(dataSearch.iPageIndex-1)*dataSearch.iPageSize + index + 1}</p>
                  </div>
                </div>
                <div className="custom-table-cell flex-basis-10 flex-basis-10-sm  action-cell">
                  <span className="mobile-column-name">Mã thông tin</span>
                  <div className="center-wrapper">
                    <p className="text-center">{item.MaThongTin}</p>
                  </div>
                </div>
                <div className="custom-table-cell flex-basis-10 flex-basis-10-sm  action-cell">
                  <span className="mobile-column-name">Thời gian đăng ký</span>
                  <div className="center-wrapper">
                    <p className="text-center"> {moment(item.NgayTao).format("HH:mm DD/MM/YYYY")}</p>
                  </div>
                </div>
                <div className="custom-table-cell flex-basis-15 flex-basis-15-sm  action-cell">
                  <span className="mobile-column-name">Họ và tên</span>
                  <div className="center-wrapper">
                    <p className="text-left">{item.HoVaTen}</p>
                  </div>
                </div>

                <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
                  <span className="mobile-column-name">Địa chỉ</span>
                  <div className="center-wrapper">
                    <p className="text-left">{item.DiaChi}</p>
                  </div>
                </div>

                <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                  <span className="mobile-column-name">Số tiền vay</span>
                  <div className="center-wrapper">
                    <p className="text-right">{formatMoney(item.SoTienVay)}</p>
                  </div>
                </div>
                <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                  <span className="mobile-column-name">Điện thoại</span>
                  <div className="center-wrapper">
                    <p className="text-right">{item.DienThoaiChe}</p>
                  </div>
                </div>

                <div className="custom-table-cell flex-basis-10 flex-basis-10-sm action-cell">
                  <div className="center-wrapper">
                    <div className="iconTableMormanCenter">
                    <BtnThongTinVay item={item} IdCuaHang={dataSearch.IdCuaHang} />
                    </div>
                  </div>
                </div>
              </div>
              ))
            }
          </div>
          <div className={"custom-table-body " +
          (dataSearch.iTotal > 0 ? "hidden" : "")}>
             <div className="custom-table-header flex-basis-100 flex-basis-100-sm">
              <p className="tab-header text-left">Không có dữ liệu</p>
            </div>
          </div>
          <div
        className={
          "paniation-new paniation-new1 d-flex justify-content-center " +
          (dataSearch.iTotal === 0 ? "hidden" : "")
        }
      >
          <nav aria-label="Page navigation">
          <Pagination
            activePage={dataSearch.iPageIndex}
            itemsCountPerPage={dataSearch.iPageSize}
            totalItemsCount={dataSearch.iTotal}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            activeClass="active"
          />
        </nav>
        </div></div>
      </div>
    </div>
  );
};
